import React from 'react';
import WaitingLoaded from '../../../common/component/waiting-loaded';
import { Typography } from '@material-ui/core';
import { ResourceGetter } from '../../../../lib/training-sdk/getter';

function Description({ programme, ...props }) {
    return (
        <Typography {...props} >
            {programme.payload.description}
        </Typography>
    )
}

function ProgrammeDescription({ programme, ...props }) {
    return (
        <ResourceGetter resource='programmes' id={programme} render={({ programme }) =>
            <WaitingLoaded data={programme} render={() => <Description {...props} programme={programme} />} />
        } />
    )
}

export default ProgrammeDescription;
